import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Tech as Desc } from './desk'
import { Tech as Mob } from './mob'

type Props = {
  images: TImages
}
export const Tech: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desc images={images} />
}
